import React, {Component} from 'react'
import CBaseComponent from '@/components/CBaseComponent'
import store from "../../../../redux";
import { storeManageListNewData} from './data'
import './index.scss'
import { gotonext} from "@/utils";
import {bindActionCreators, compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {Button, message, Modal} from "antd";
import {dpeallcitylist} from "../../../../utils/citylist";
import {
  refreshMenu,
} from "../../../../redux/common/action";
import {getbaseInfo} from "../../../../servers/menuAPI";
import {dpeselectmap} from "../../../../utils/dpedatadef";
@CBaseComponent
class Legal extends Component{

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.computeddata = this.computeddata.bind(this)
    this.computeddata1 = this.computeddata1.bind(this)
  }


  state = {
    data: storeManageListNewData,
    appform:''
  }

  computeddata(d,value){
    let str = []
    dpeallcitylist.forEach(item=>{
        if (Number(item.id) === Number(d)){
          str = item.children
        }
    })
    let s = ''
    str.forEach(item=>{
      if (item.id === value){
        s = item.name
      }
    })
    return s
  }

  computeddata3(d){
    let str = ''
    dpeallcitylist.forEach(item=>{
      if (Number(item.id) === Number(d)){
        str = item.name
      }
    })
    return str
  }

  computeddata2(d,d1,d2){
    let str = []
    dpeallcitylist.forEach(item=>{
      if (Number(item.id) === Number(d)){
        item.children.forEach(item2=>{
          if (item2.id === d1){
            if (item2.children.length === 1 && item2.children[0].name === '' && item2.children[0].id === ''){
              str = []
            } else {
              str = item2.children
            }
          }
        })
      }
    })
    let s = ''
    str.forEach(item=>{
      if (item.id === d2) {
        s = item.name
      }
    })
    return s
  }

  computeddata1(type,d){
    const arr =dpeselectmap[type]
    let str = ''
    arr.forEach(item=>{
      if(d === item.id) {
        str = item.name
      }
    })
    return str
  }

  onSelect(){
    const params = {
      annual:localStorage.getItem('year'),
      museumid:store.getState().libraryid,
      extra:true,

    }
    getbaseInfo(params).then(res=>{
      if (res.statecode === 0 && res.records.length >0) {
        const data = []
        for (let i=0;i<34;i++){
          const obj = {}
          obj.id = ''
          obj.name =''
          obj.placeholder=''
          obj.type= 'input'
          obj.checkType= 'required'
          obj.newDisabled=true
          obj.editDisabled=true
          obj.newShow= true
          obj.editShow=true
          obj.ifEdit= false
          obj.value= ''
          obj.options=[]
          obj.expand = {
            autosize: {minRows: 4, maxRows: 10}
          }
          obj.hasupload = ''
          obj.jpath = ''
          obj.tips =''
          obj.showeditbtn = false
          data.push(obj)
        }

        data[0].id = 'name'
        data[0].jpath = 'name'
        data[0].name = '博物馆备案名称'
        data[0].value = res.records[0].name
        data[0].newDisabled=true
        data[0].editDisabled=true

        data[1].id = 'natureid'
        data[1].jpath = 'natureid'
        data[1].type= 'select'
        data[1].name = '博物馆性质'
        data[1].value = this.computeddata1('13',res.records[0].natureid)

        data[2].id = 'corporateid'
        data[2].jpath = 'corporateid'
        data[2].type= 'select'
        data[2].name = '法人类型'
        data[2].value = this.computeddata1('1C',res.records[0].corporateid)

        data[3].id = 'socialcode'
        data[3].jpath = 'socialcode'
        data[3].name = '统一社会信用代码'
        data[3].value = res.records[0].socialcode

        data[4].id = 'regauthority'
        data[4].jpath = 'regauthority'
        data[4].name = '法人登记机关'
        data[4].value = res.records[0].regauthority

        data[5].id = 'subjectid'
        data[5].jpath = 'subjectid'
        data[5].type= 'select'
        data[5].name = '题材类型'
        data[5].value = this.computeddata1('17',res.records[0].subjectid)

        data[6].id = 'holder'
        data[6].jpath = 'holder'
        data[6].name = '举办者'
        data[6].value = res.records[0].holder

        data[7].id = 'belonglevelid'
        data[7].jpath = 'belonglevelid'
        data[7].type= 'select'
        data[7].name = '隶属层级'
        data[7].value = this.computeddata1('1B',res.records[0].belonglevelid)

        data[8].id = 'legalman'
        data[8].jpath = 'legalman'
        data[8].name = '法定代表人'
        data[8].value = res.records[0].legalman

        data[9].id = 'createdate'
        data[9].jpath = 'createdate'
        data[9].name = '设立时间'
        data[9].type= 'date'
        data[9].value = res.records[0].createdate

        data[10].id = 'firstdate'
        data[10].jpath = 'firstdate'
        data[10].name = '开馆日期'
        data[10].type= 'date'
        data[10].value = res.records[0].firstdate

        data[11].id = 'openperiod'
        data[11].jpath = 'openperiod'
        data[11].name = '开放时间'
        data[11].value = res.records[0].openperiod

        data[12].id = 'levelid'
        data[12].jpath = 'levelid'
        data[12].name = '质量等级'
        data[12].type= 'select'
        data[12].value = this.computeddata1('14',res.records[0].levelid)


        data[13].id = 'freeopenid'
        data[13].jpath = 'freeopenid'
        data[13].type= 'select'
        data[13].name = '免费开放'
        data[13].value = this.computeddata1('1A',res.records[0].freeopenid)

        data[14].id = 'centralsubsidyid'
        data[14].jpath = 'centralsubsidyid'
        data[14].type= 'select'
        data[14].name = '是否纳入中央补助免费开放博物馆纪念馆名单'
        data[14].value = this.computeddata1('1M',res.records[0].centralsubsidyid)

        data[15].id = 'provinceid'
        data[15].jpath = 'provinceid'
        data[15].name = '行政区划'
        data[15].value = this.computeddata3(res.records[0].provinceid)
        data[15].type= 'select'

        data[16].id = 'regionid'
        data[16].jpath = 'regionid'
        data[16].value = this.computeddata(res.records[0].provinceid,res.records[0].regionid)
        data[16].type= 'select'
        data[16].placeholder= '请选择'


        data[17].id = 'cityid'
        data[17].jpath = 'cityid'
        data[17].value = this.computeddata2(res.records[0].provinceid,res.records[0].regionid, res.records[0].cityid)
        data[17].type= 'select'
        data[17].placeholder= '请选择'

        data[18].id = 'address'
        data[18].jpath = 'address'
        data[18].name = '馆舍地址'
        data[18].value = res.records[0].address

        data[19].id = 'addresslon'
        data[19].jpath = 'addresslon'
        data[19].name = '馆址经度'
        data[19].value = res.records[0].addresslon

        data[20].id = 'addresslat'
        data[20].jpath = 'addresslat'
        data[20].name = '馆址纬度'
        data[20].value = res.records[0].addresslat



        data[21].id = 'postcode'
        data[21].jpath = 'postcode'
        data[21].name = '邮政编码'
        data[21].value = res.records[0].postcode

        data[22].id = 'equityid'
        data[22].jpath = 'equityid'
        data[22].type= 'select'
        data[22].name = '馆舍产权性质'
        data[22].value = this.computeddata1('19',res.records[0].equityid)

        data[23].id = 'buildingnatureid'
        data[23].jpath = 'buildingnatureid'
        data[23].type= 'select'
        data[23].name = '馆舍建筑性质'
        data[23].value = this.computeddata1('18',res.records[0].buildingnatureid)

        data[24].id = 'nationalreserve'
        data[24].jpath = 'nationalreserve'
        data[24].name = '国保单位名称'
        data[24].value = res.records[0].nationalreserve

        data[25].id = 'nationalreserveno'
        data[25].jpath = 'nationalreserveno'
        data[25].name = '国保单位批次'
        data[25].value = res.records[0].nationalreserveno

        data[26].id = 'roomarea'
        data[26].jpath = 'roomarea'
        data[26].name = '馆舍建筑面积'
        data[26].value = res.records[0].roomarea
        data[26].tips = '仅允许输入整数数字'
        data[26].type = 'number'



        data[27].id = 'showarea'
        data[27].jpath = 'showarea'
        data[27].name = '展厅面积'
        data[27].value = res.records[0].showarea
        data[27].tips = '仅允许输入整数数字'
        data[27].type = 'number'

        data[28].id = 'storearea'
        data[28].jpath = 'storearea'
        data[28].name = '库房面积'
        data[28].value = res.records[0].storearea
        data[28].tips = '仅允许输入整数数字'
        data[28].type = 'number'

        data[29].id = 'repairarea'
        data[29].jpath = 'repairarea'
        data[29].name = '实验修复面积'
        data[29].value = res.records[0].repairarea
        data[29].tips = '仅允许输入整数数字'
        data[29].type = 'number'

        data[30].id = 'teacharea'
        data[30].jpath = 'teacharea'
        data[30].name = '教育空间面积'
        data[30].value = res.records[0].teacharea
        data[30].tips = '仅允许输入整数数字'
        data[30].type = 'number'

        data[31].id = 'publicarea'
        data[31].jpath = 'publicarea'
        data[31].name = '公共服务面积'
        data[31].value = res.records[0].publicarea
        data[31].tips = '仅允许输入整数数字'
        data[31].type = 'number'

        data[32].id = 'repairqualificationid'
        data[32].jpath = 'repairqualificationid'
        data[32].name = '可移动文物修复资质'
        data[32].type = 'select'
        data[32].value = this.computeddata1('1N',res.records[0].repairqualificationid)

        data[33].id = 'repairqualificationdate'
        data[33].jpath = 'repairqualificationdate'
        data[33].name = '取得可移动文物修复资质的年份'
        data[33].value = res.records[0].repairqualificationdate

          const d = JSON.parse(JSON.stringify(this.state.data))
          d[0].data = data
          this.setState({
            data:d,
            appform:res.records[0].appform
          })
      } else {
        message.error('未查询到博物馆信息');
      }
    })
  }


  //下一步
   onSubmit(){
    gotonext()
    this.props.history.push({
      pathname: '/informationDeclaration/standardManage/organization/legalProvince',
    });
  }



  componentWillUnmount() {
    // 在组件卸载时取消订阅
    if (this.unsubscribe) this.unsubscribe();
  }

  componentDidMount(){
    this.onSelect()
    let currentState = store.getState();
    store.subscribe(() => {
      let previousState = currentState;
      currentState = store.getState();
      if (previousState.libraryid !== currentState.libraryid) {
        this.onSelect()
        this.props.refreshMenu(true)
      }
      if (previousState.year !== currentState.year) {
        this.onSelect()
        this.props.refreshMenu(true)
      }
    })
  }

  downloads(file){
    window.location.href = file
  }

  render(){
    return (
      <div className='detail-container' id="top">
        {this.state.appform && this.state.appform!=='' &&
            <div className='shenhe-item' style={{color:'#1e9fff',textAlign:'right',fontSize:'16px',fontWeight:'bold',cursor:'pointer'}} onClick={()=>{this.downloads(this.state.appform)}}>
              运行评估申报书
            </div>
        }
        {this.state.data[0].data.map(item=>{
          return(
              <div style={{marginBottom:'10px',display:'flex'}}>
                <span style={{fontWeight:'bold',marginRight:'20px',width:'150px',display:'inline-block',textAlign:'right'}}>{item.name !== '' ? item.name+':':'行政区划:'}</span>
                <span>{item.value}</span>
              </div>
          )
        })}
        <div className='detail-submit' style={this.props.collapsed?{width:'calc(100vw - 260px)',left:'260px'}:{width:'calc(100vw - 5px)',left:'50px'}}>
          <Button type="primary" className='yl' onClick={this.onSubmit}>下一步</Button>
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    year: state.year,
    collapsed: state.collapsed,  // 侧边栏是否展开
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    refreshMenu: bindActionCreators(refreshMenu, dispatch),
  };
};
export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Legal);

